import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { AuthService } from 'src/app/auth/auth.service';
import { PageResponse } from 'src/app/auth/base-capacitor-http';
import { Move, MoveSearchParams, MoveSortOption, MovesService, MoveStatus } from 'src/app/services/app/moves.service';
import { TrailerStatus } from 'src/app/services/app/trailer.service';
import { UtilitieService as UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'app-moves-history',
  templateUrl: './moves-history.component.html',
  styleUrls: ['./moves-history.component.css'],
})
export class MovesHistoryComponent implements OnInit {
  page: PageResponse<Move>;

  pageSizeOptions = [5, 10, 25];
  searchParams: MoveSearchParams;
  viewModes = ['movesList', 'moveView'];
  viewMode = this.viewModes[0];
  selectedMove: Move;
  range: FormGroup;
  reportMoves: Move[] = [];
  constructor(
    private moveSevice: MovesService,
    private utilService: UtilitieService,
    private authService: AuthService,

  ) { }

  async emailMovesReport() {
    const userData = await this.authService.getUserData();

    const result = await this.moveSevice.openMoveReportDialog(this.reportMoves, userData.email);
    
    if(result){
      this.utilService.openSnackBar('Report has been emailed', '');
    }
    
  }

  viewMove(move: Move) {
    this.selectedMove = move;
    this.viewMode = this.viewModes[1];
  }

  viewMoves() {
    this.viewMode = this.viewModes[0];
  }

  setTruckStatus(move: Move) {
    // setting truck default status
    let truckColor = { color: 'green' };

    const statusColorMap = {
      [TrailerStatus.LOADED]: 'green',
      [TrailerStatus.EMPTY]: 'white',
      [TrailerStatus.OUT_OF_SERVICE]: 'red',
    };
    truckColor.color = statusColorMap[move.end.trailer.status];
    return truckColor;
  }
  async searchByDateRanges() {
    if (!this.range.value.start && !this.range.value.end) {
      return;
    }
    const startDate = new Date(this.range.value.start);
    const endDate = new Date(this.range.value.end);

    //the end date needs to be setup to the date right before the next date to include all the that dates data
    // Increment the date by 1 day
    endDate.setDate(endDate.getDate() + 1);

    // Set the time to 00:00:00 hours
    endDate.setHours(0, 0, 0, 0);

    // Subtract 1 millisecond to get the last millisecond of the specified day
    endDate.setMilliseconds(endDate.getMilliseconds() - 1);
    const start: number = startDate.getTime();
    const end: number = endDate.getTime();
    this.searchParams.start = start;
    this.searchParams.end = end;
    this.searchParams.page = 0;
    this.searchMoves();

    this.reportMoves = await this.moveSevice.getMovesReportData(start, end);
  }

  async resetTimeRanges() {
    this.initDateRangeForm();
    this.searchParams.page = 0;
    this.searchParams.start = null;
    this.searchParams.end = null;
    this.searchMoves();
    this.reportMoves = [];
  }

  async searchMoves() {
    this.page = await this.moveSevice.searchMovesByStatus(this.searchParams);
  }

  async handlePageEvent(e: PageEvent) {
    this.searchParams.size = e.pageSize;
    this.searchParams.page = e.pageIndex;
    this.searchMoves();
  }

  initDateRangeForm() {

    this.range = new FormGroup({
      start: new FormControl<Date | null>(null),
      end: new FormControl<Date | null>(null),
    });
  }

  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);
    this.page = new PageResponse();
    this.searchParams = {
      page: 0,
      size: 10,
      completed: true,
      start: null,
      end: null,
      sort: MoveSortOption.COMPLETE_NEW,
      search: MoveStatus.COMPLETE
    };
    this.initDateRangeForm();
    await this.searchMoves();
    this.utilService.updateLoading(false);
  }

}
